var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "plombs_maker" },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.is_load, rounded: "sm" } },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c("h1", { staticClass: "title text-center pb-5 mt-5" }, [
                _vm._v("Створення / Переміщення пломб"),
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "doc_title" },
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "6", xl: "6", xs: "12", sm: "6" } },
                    [
                      _c(
                        "b-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "b-row",
                            { staticClass: "doc_title mt-3" },
                            [
                              _c("b-col", { attrs: { sm: "3" } }, [
                                _c("label", { attrs: { for: "doc_title" } }, [
                                  _vm._v("Серія *"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { sm: "4" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      state: _vm.is_valid_seria,
                                      maxlength: "30",
                                      id: "doc_title",
                                      size: "sm",
                                    },
                                    model: {
                                      value: _vm.form.seria,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "seria", $$v)
                                      },
                                      expression: "form.seria",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    { attrs: { id: "input-live-feedback" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\tПотрібно заповнити серію\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "start_seria mt-3" },
                            [
                              _c("b-col", { attrs: { sm: "3" } }, [
                                _c("label", { attrs: { for: "start_seria" } }, [
                                  _vm._v("Початок серії*"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { sm: "4" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      state: _vm.is_valid_start,
                                      maxlength: "30",
                                      id: "start_seria",
                                      size: "sm",
                                    },
                                    model: {
                                      value: _vm.form.number_from,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "number_from", $$v)
                                      },
                                      expression: "form.number_from",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "doc_title mt-3" },
                            [
                              _c("b-col", { attrs: { sm: "3" } }, [
                                _c("label", { attrs: { for: "end_seria" } }, [
                                  _vm._v("Кінець серії*"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { sm: "4" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      state: _vm.is_valid_end,
                                      maxlength: "30",
                                      id: "end_seria",
                                      size: "sm",
                                    },
                                    model: {
                                      value: _vm.form.number_to,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "number_to", $$v)
                                      },
                                      expression: "form.number_to",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "border-left",
                      attrs: { lg: "6", xl: "6", xs: "12", sm: "6" },
                    },
                    [
                      !_vm.obj_to_null(this.user)
                        ? _c(
                            "div",
                            { staticClass: "user_add cursor-pointer fs-xxl" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "add user",
                                  on: { click: _vm.add_user },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa add_user fa-plus-square",
                                    attrs: {
                                      title: "",
                                      "data-type": "delegate_users",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Оберіть користувача")]),
                                ]
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "user_to_fire" },
                            [
                              _vm.obj_to_null(this.user)
                                ? _c("user_block", {
                                    key: _vm.user.id,
                                    attrs: {
                                      can_del: true,
                                      del_triger: _vm.remove_fire_from_doc,
                                      user: _vm.user,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "button_block row mt-5 pb-5" }, [
            _c(
              "div",
              {
                staticClass:
                  "next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3",
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-lg btn-block btn-outline-success waves-effect waves-themed",
                    attrs: { disabled: !_vm.is_save_active },
                    on: {
                      click: function ($event) {
                        return _vm.save("create")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "fal fa-download mr-1" }),
                    _vm._v("\n\t\t\t\t\tСтворити\n\t\t\t\t"),
                  ]
                ),
                _vm._v(" "),
                _vm.save_has_err
                  ? _c("b-form-text", { attrs: { id: "input-live-help" } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(_vm.save_err_txt) + "\n\t\t\t\t"
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3",
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-lg btn-block btn-outline-info waves-effect waves-themed",
                    attrs: { disabled: !_vm.is_move_active },
                    on: {
                      click: function ($event) {
                        return _vm.save("move")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "fal fa-eject mr-1" }),
                    _vm._v("\n\t\t\t\t\t Переміщення\n\t\t\t\t"),
                  ]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }